/**
 * Länken som öppnar BankID-appen på samma enhet, och vart en inloggad
 * användare ska. Rent från React och Firebase.
 *
 * iPhone/iPad: samma länk som alltid — https://app.bankid.com med sajtens
 * adress som retur. iOS öppnar returadressen i webbläsaren när appen är klar.
 *
 * Android: Chrome lämnar bara över https://app.bankid.com till appen om
 * telefonens inställning "Öppna länkar som stöds" är på för BankID. Ett enda
 * val av "Chrome" i frågan "Öppna med…" stänger av den för alltid, och då
 * laddas BankID:s webbsida i stället för appen (sett 2026-09-24, både drift
 * och testmiljö). Formen intent:// går rakt till appen oavsett den
 * inställningen; saknas appen faller Chrome tillbaka på BankID:s webbsida.
 * redirect=null gör att appen lämnar tillbaka till webbläsaren, där sidan
 * ligger kvar och frågar efter status. Firefox på Android förstår inte
 * intent:// och får appens egen adressform.
 */

export function isAndroid(userAgent: string): boolean {
  return /Android/i.test(userAgent);
}

const appBankidUrl = (autoStartToken: string, redirect: string): string =>
  `https://app.bankid.com/?autostarttoken=${encodeURIComponent(autoStartToken)}&redirect=${redirect}`;

export function bankidAppUrl(autoStartToken: string, returnOrigin: string, userAgent: string): string {
  if (!isAndroid(userAgent)) {
    return appBankidUrl(autoStartToken, encodeURIComponent(returnOrigin));
  }
  const token = encodeURIComponent(autoStartToken);
  if (/Firefox/i.test(userAgent)) {
    return `bankid:///?autostarttoken=${token}&redirect=null`;
  }
  const fallback = encodeURIComponent(appBankidUrl(autoStartToken, 'null'));
  return `intent://?autostarttoken=${token}&redirect=null#Intent;scheme=bankid;S.browser_fallback_url=${fallback};end`;
}

/** Vart en inloggad användare skickas, efter roll. */
export function landingPathFor(role: string | null | undefined): string {
  if (role === 'hyria_admin') return '/hyria-dashboard';
  if (role === 'brfadmin') return '/dashboard';
  return '/';
}
